import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";

interface ListProps {
    light: string;
}
export const Container = styled(Box)`
  .react-datepicker__month-container,
  .react-datepicker__header {
    background-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-white)"
            : "var(--chakra-colors-gray-900)"};

    color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-700)"
            : "var(--chakra-colors-gray-100)"};
  }

  .react-datepicker__day-name,
  .react-datepicker__current-month,
  .react-datepicker__day {
    color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-700)"
            : "var(--chakra-colors-gray-100)"};
  }

  .react-datepicker__day:hover {
    background-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-200)"
            : "var(--chakra-colors-gray-600)"};
  }

  .react-datepicker {
    border: 1px solid
      ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-200)"
            : "var(--chakra-colors-gray-900)"};
    text-transform: capitalize;
  }

  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover {
    background-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-100)"
            : "var(--chakra-colors-gray-700)"};
  }

  .react-datepicker__month--selected,
  .react-datepicker__day--in-range {
    background-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-blue-300)"
            : "var(--chakra-colors-blue-600)"};
  }

  .react-datepicker__triangle::after {
    border-bottom-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-white)"
            : "var(--chakra-colors-gray-900)"} !important;
  }
  .react-datepicker__triangle::before {
    border-bottom-color: ${(props: ListProps) =>
        props.light == "light"
            ? "var(--chakra-colors-gray-200)"
            : "var(--chakra-colors-gray-900)"} !important;
  }
`;